import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationService } from '../../../../services/navigation/navigation.service';

export interface AccountExistedDialogComponentData {
  redirectLink?: string;
  email?: string;
  phoneNr?: string;
  errorMessage?: string;
}

@Component({
  selector: 'app-account-existed-dialog',
  templateUrl: './account-existed-dialog.component.html',
  styleUrls: ['./account-existed-dialog.component.scss'],
})
export class AccountExistedDialogComponent {
  public email: string;
  public phoneNr: string;
  public isEmailExists: boolean;
  public isPhoneNrExists: boolean;

  private readonly ERROR_MESSAGE = {
    EMAIL_EXISTS: 'error.email-exists',
    PHONE_EXISTS: 'error.phoneNr-exists',
  };

  private redirectLink: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: AccountExistedDialogComponentData,
    private dialogRef: MatDialogRef<AccountExistedDialogComponent>,
    private navigationService: NavigationService
  ) {
    this.redirectLink = this.data?.redirectLink;
    this.email = this.data?.email;
    this.phoneNr = this.data?.phoneNr;

    this.isEmailExists =
      this.data?.errorMessage === this.ERROR_MESSAGE.EMAIL_EXISTS;
    this.isPhoneNrExists =
      this.data?.errorMessage === this.ERROR_MESSAGE.PHONE_EXISTS;
  }

  public async navigateToLogin() {
    await this.navigationService.navigateToLogin(
      this.redirectLink,
      this.isEmailExists ? this.email : null,
      this.isPhoneNrExists ? this.phoneNr : null
    );
    this.closeDialog();
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
}
